import {
  getPublicProductsSubscriptionAmount,
  getPublicProductsSubscriptionCurrency,
  isPublicProductsSubscriptionRequired,
} from '../config/publicProductsSubscription';
import { parseWipayDataQueryParam } from './payment/parseWipayCallback';
import { generateSubscriptionWipayOrderId } from './payment/wipayOrderId';
import {
  buildWipayRequestParams,
  requestWipayPaymentUrl,
} from './payment/buildWipayRequest';
import { resolveWipayCountryCode } from './payment/wipayPlatform';

export { parseWipayDataQueryParam };
export { generateSubscriptionWipayOrderId };

export const PUBLIC_PRODUCTS_SUBSCRIPTION_PURPOSE = 'public_products_subscription';

/**
 * Start WiPay hosted payment for public products subscription.
 * @param {{ identityId: string, firestoreUserDocId: string, navigate: import('react-router-dom').NavigateFunction }} args
 */
export async function initiatePublicProductsSubscriptionPayment({
  identityId,
  firestoreUserDocId,
  navigate,
}) {
  if (!isPublicProductsSubscriptionRequired()) {
    throw new Error('Subscription payment is not configured.');
  }
  if (!identityId || !firestoreUserDocId) {
    throw new Error('You must be signed in to subscribe.');
  }

  const amount = getPublicProductsSubscriptionAmount();
  const currency = getPublicProductsSubscriptionCurrency();
  const gatewayPaymentType = process.env.REACT_APP_PAYMENT_TYPE || 'wipay';
  const wipayResponseUrl = process.env.REACT_APP_WIPAY_RESPONSE_URL || 'http://localhost:3000/payment/response';
  const wipayAccountNumber = process.env.REACT_APP_WIPAY_ACCOUNT_NUMBER || '1234567890';
  const wipayEnvironment = process.env.REACT_APP_WIPAY_ENVIRONMENT || 'sandbox';
  const wipayFeeStructure = process.env.REACT_APP_WIPAY_FEE_STRUCTURE || 'merchant_absorb';
  const wipayCountryCode = resolveWipayCountryCode();
  const wipayCardType = process.env.REACT_APP_WIPAY_CARD_TYPE || 'visa';

  const wipayOrderId = generateSubscriptionWipayOrderId();
  const wipayData = {
    payment_purpose: PUBLIC_PRODUCTS_SUBSCRIPTION_PURPOSE,
    userId: identityId,
    userDocId: firestoreUserDocId,
    amount,
    currency,
  };

  if (gatewayPaymentType === 'simulated') {
    const encodedData = encodeURIComponent(JSON.stringify(wipayData));
    navigate(
      `/payment/response?status=success&order_id=${encodeURIComponent(
        wipayOrderId
      )}&data=${encodedData}&total=${encodeURIComponent(String(amount))}&currency=${encodeURIComponent(currency)}`
    );
    return;
  }

  const parameters = buildWipayRequestParams({
    accountNumber: wipayAccountNumber,
    environment: wipayEnvironment,
    feeStructure: wipayFeeStructure,
    responseUrl: wipayResponseUrl,
    wipayOrderId,
    paymentAmount: amount,
    wipayData: { ...wipayData, currency },
    countryCode: wipayCountryCode,
    currency,
    cardType: wipayCardType,
  });
  parameters.set('currency', currency);

  const json = await requestWipayPaymentUrl(parameters);
  if (json.url) {
    window.location.href = json.url;
  } else {
    throw new Error(json.message || 'Could not start payment.');
  }
}
